import tbWhenScrolled from './tb-when-scrolled.directive'

export default angular
  .module('tb.when-scrolled', [])
  .directive('tbWhenScrolled', tbWhenScrolled)
  .name
